module.exports = __webpack_public_path__ + "static/media/bring-front.cdb1a0ff.svg";